/** @format */

import React, { useCallback, useState } from 'react';
import { CallLogsFilterInput } from '../types/callLogs.types';
import CallLogsTable from '../components/CallLogsTable';

interface CallLogsTableContainerProps {
  filter?: CallLogsFilterInput;
}

const CallLogsTableContainer: React.FC<CallLogsTableContainerProps> = ({ filter }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  return (
    <CallLogsTable
      filter={filter}
      refreshTrigger={refreshTrigger}
      onRefresh={handleRefresh}
    />
  );
};

export default CallLogsTableContainer;
